<template>
	<div>
		<v-layout row wrap
			justify-end
			align-center
			v-if="id"
			class="header-booking-data">
			<v-flex xs1>
				<p>Gasto Total</p>
				<span>${{ totalExpenses | round }}</span>
			</v-flex>
			<v-flex xs1>
				<v-btn class="btn-tab" flat
					:class="{ 'active' : $route.name === 'companies-edit' }"
					@click="goTo('edit')">
					Detalle
				</v-btn>
			</v-flex>
			<v-flex xs1>
				<v-btn class="btn-tab" flat
					:class="{ 'active' : $route.name === 'companies-statistics' }"
					@click="goTo('statistics')">
					Estadística
				</v-btn>
			</v-flex>
			<v-flex xs1>
				<v-btn class="btn-tab" flat
					:class="{ 'active' : $route.name === 'companies-history' }"
					@click="goTo('history')">
					Historial
				</v-btn>
			</v-flex>
		</v-layout>
		<table-run
			:columns="columns"
			:rows="rows"
			:include-delete="false"
			include-options
			include-settings
			@on-sortable-event="columnSortableEvent"
			@on-search-event="searchByColumn"
			@go-to-edit-page="goToEdit"
			class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>{{ props.row.bookingCode }}</td>
				<td>{{ props.row.bookingDate | parseDate }}</td>
				<td>{{ props.row.roomTypeCode }}</td>
				<td>{{ props.row.bookingStart | parseDate('DD/MM/YYYY HH:mm:ss') }}</td>
				<td>{{ props.row.bookingEnd | parseDate('DD/MM/YYYY HH:mm:ss') }}</td>
				<td>{{ props.row.totalExpenses | round | currency(props.row.currency) }}</td>
			</template>
		</table-run>
		<div class="text-xs-right mt-3">
			<v-pagination
				:length="totalPages"
				v-model="params.page"
			></v-pagination>
  		</div>
		<v-dialog v-model="dialog" persistent width="644">
			<v-card class="pb-2">
				<table-run
					:columns="columnsDetails"
					:rows="details"
					:include-delete="false"
					:include-export-to-excel="false"
					:include-options="false"
					:include-settings="false"
					:include-search="false"
					:selectable="false"
					@on-sortable-event="columnSortableEvent"
					class="no-selectable-table">
					<template slot="rows" scope="props">
						<td>{{ props.row.date | parseDate }}</td>
						<td>{{ props.row.hour | parseDate('HH:mm:ss') }}</td>
						<td>{{ props.row.name }}</td>
						<td>{{ props.row.total | round | currency(props.row.currency) }}</td>
					</template>
				</table-run>
				<v-layout wrap justify-center my-4>
					<v-btn class="btn-save" @click.native.stop="closeDialog">
						Cerrar
					</v-btn>
				</v-layout>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import TableRun from 'table-run';
	import { currency, parseDate, round } from '@/shared/filters';

	function closeDialog() {
		this.rowId = 0;
		this.dialog = false;
	}

	function columnSortableEvent() {}

	function goTo(route) {
		this.$router.push({ name: `companies-${route}`, params: { id: this.id } });
	}

	function goToEdit({ id }) {
		this.rowId = id;
		this.dialog = true;
	}

	function searchByColumn() {}

	function data() {
		return {
			columns: [
				{ id: 1, name: '# Reserva', code: 'booking_code', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Fecha de reserva', code: 'booking_date', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Habitación', code: 'room_type_code', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Check In', code: 'booking_start', isSortable: { down: true, up: false } },
				{ id: 5, name: 'Check Out', code: 'booking_end', isSortable: { down: true, up: false } },
				{ id: 6, name: 'Gasto Total', code: 'total_expenses', isSortable: { down: true, up: false } },
			],
			columnsDetails: [
				{ id: 1, name: 'Fecha', code: 'date', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Hora', code: 'hour', isSortable: { down: true, up: false } },
				{ id: 3, name: 'Producto', code: 'name', isSortable: { down: true, up: false } },
				{ id: 4, name: 'Gasto', code: 'total', isSortable: { down: true, up: false } },
			],
			details: [
				{ id: 1, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 2, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 3, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 4, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 5, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 6, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 7, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 8, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 9, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 10, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 11, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 12, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 12, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 14, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 15, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 16, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 17, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 18, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 19, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 20, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 21, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 22, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 23, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 24, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 25, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 26, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 27, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 28, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 29, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 30, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 31, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 32, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 33, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 34, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 35, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 36, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 37, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 38, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 39, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 40, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 41, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 42, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 43, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 44, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
				{ id: 45, date: '2018-08-15', hour: '2018-08-15 13:35:35', name: 'Coca-Cola', total: 180 },
				{ id: 46, date: '2018-08-15', hour: '2018-08-15 12:17:30', name: 'Polo', total: 180 },
			],
			dialog: false,
			params: {
				page: 1,
			},
			rowId: 0,
			rows: [
				{
					id: 1,
					bookingCode: '186989',
					bookingDate: '2018-08-15',
					bookingEnd: '2017-05-29 13:35:35',
					bookingStart: '2017-05-29 13:35:35',
					currency: '$',
					roomTypeCode: 'DSQ',
					totalExpenses: 180,
				},
				{
					id: 2,
					bookingCode: '186989',
					bookingDate: '2018-08-15',
					bookingEnd: '2017-05-29 12:17:30',
					bookingStart: '2017-05-29 12:17:30',
					currency: '$',
					roomTypeCode: 'DSQ',
					totalExpenses: 180,
				},
			],
			totalExpenses: 0,
			totalPages: 1,
		};
	}

	export default {
		name: 'companies-history',
		components: {
			TableRun,
		},
		data,
		filters: {
			currency,
			parseDate,
			round,
		},
		methods: {
			closeDialog,
			columnSortableEvent,
			goTo,
			goToEdit,
			searchByColumn,
		},
		props: {
			id: {
				default: 0,
				type: [Number, String],
			},
		},
	};
</script>

<style lang="scss" scoped>
	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 55px;
		width: calc(100% - 230px);

		div {
			padding-bottom: 0px !important;
			padding-top: 0px !important;
		}

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}
	}

	.btn-tab {
		border-bottom: 3px solid transparent;

		&:hover,
		&.active {
			border-color: map-get($colors, default-skyblue);
		}
	}
</style>



// WEBPACK FOOTER //
// companies-history.vue?f01df936